import { Controller } from "@hotwired/stimulus"

// One learner-side flip card: clicking (or Enter/Space — the card is a button)
// rotates the card between its front and back faces. The face turned away is
// hidden from assistive tech too, so the button's accessible name always matches
// the side the learner can actually see.
export default class extends Controller {
  static targets = ["front", "back"]

  flip() {
    const flipped = this.element.classList.toggle("is-flipped")

    this.element.setAttribute("aria-pressed", flipped ? "true" : "false")
    this.setFaceHidden(this.frontTarget, flipped)
    this.setFaceHidden(this.backTarget, !flipped)
  }

  setFaceHidden(face, hidden) {
    if (hidden) {
      face.setAttribute("aria-hidden", "true")
    } else {
      face.removeAttribute("aria-hidden")
    }
  }
}
